<template>
<div>
    <!-- <h4><span v-html="generateWelcomeMessage"></span></h4> -->
  <v-card
    flat
  >
    <v-row justify="start">
        <v-col
          v-for="card in getAuthorizedCards"
          :key="card.title"
          :cols="card.flex"
        >
          <v-card
          router :to="card.route"
          >
            <v-img
              :src="card.src"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="200px"
            >
              <v-card-title v-text="card.title"></v-card-title>
            </v-img>
            <v-card-actions>
              <v-card-text v-text="card.description"></v-card-text>
              <v-spacer></v-spacer>
              <v-btn text class="white">
                 <v-icon color="secondary">{{ card.icon }}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import auth from '@/components/Auth/AuthService'
import { version } from '../../package'

let rh = require('@/components/APIs/RequestHandler')

export default {
  name: 'home',
  props: ['auth'],
  data: () => ({
    user: null,
    appVersion: version,
    authenticated: auth.authenticated,
    drawer: false,
    image: '@/assets/logo.png',
    home: [
      { text: 'Home', route: '/' }
    ],
    cards: [
      { title: 'Users', description: 'Search for User details', src: require('@/assets/profile-min.png'), flex: 4, route: '/users', icon: 'account_circle', roles: ['admin'] },
      { title: 'Notifications', description: 'Send notifications to users', src: require('@/assets/logo.png'), flex: 4, route: '/notifications', icon: 'email', roles: ['admin'] },
      { title: 'Cards', description: 'Info and tap to save cards', src: require('@/assets/quberlogo.png'), flex: 4, route: '/cards', icon: 'collections', roles: ['admin'] },
      { title: 'Contests', description: 'Save 2 Win details', src: require('@/assets/questionnaire.png'), flex: 4, route: '/contests', icon: 'ballot', roles: ['admin'] },
      { title: 'Aggregators', description: 'Linked transaction source info', src: require('@/assets/reports.png'), flex: 4, route: '/fis', icon: 'account_balance', roles: ['admin'] }
    ]
  }),
  created () {
    this.initialize()
  },
  async mounted () {
    // if (!auth.isAuthenticated()) {
    //   console.log('popping up login in Home')
    //   await auth.login()
    // } else {
    //   auth.hide()
    // }
  },
  methods: {
    async initialize () {
    }
  },
  computed: {
    generateWelcomeMessage () {
      if (this.authenticated) {
        var quberUser = auth.getQuberUser()
        if (quberUser) {
          return 'Welcome ' + auth.getQuberUser().firstName + ' ' + auth.getQuberUser().lastName + '!'
        }
      } else {
        return 'You are not logged in! Please click LOGIN above to continue.'
        // return 'You are not logged in! Please <a @click="auth.login()">Log In</a> to continue.'
      }
      return ''
    },
    getAuthorizedCards () {
      var filtered = this.cards.filter(function (obj) {
        return auth.hasAnyRole(obj.roles)
      })
      return filtered
    }
  }

}
</script>

<style>
  a {
    cursor: pointer;
  }
</style>
